import * as React from 'react';
import useAuth from '../../features/hooks/useAuth';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import styled from 'styled-components';
import Input from '@mui/material/Input';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import moment from 'moment';
import nameStringFn from '../../data/nameStringFn';
import { Span } from '../../Styles/CommonStyles';



const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
`;

const DailogActionWrapper =styled.div`
  display: flex;
  align-content: flex-end;
  
`

const FieldWrapper = styled.div`
  display: flex;
`

const FieldLabel = styled.div`
  font-weight: bold;
  margin-bottom: 5px;
`;

const FieldValue = styled.div`
  margin-bottom: 15px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TableHeader = styled.th`
  text-align: left;
  padding: 8px;
`;

const TableCell = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
`;

const datePickerStyle = styled.div`
  background-color:lightgreen ;
`
const cadreArray = ["CWES-GrA", "CWES-GrB", "Hydromet", "Scientific","Others"];

export default function UserdetailsModal({userdetailmodalopen,userdetailModaldata, handleUserDetailModalClose}) {

  const Auth = useAuth();
  console.log(userdetailModaldata && Object.entries(userdetailModaldata?.designation))

  const fields = userdetailModaldata? [
    { label: 'Name', value: `${nameStringFn(userdetailModaldata)}`},
    { label: 'Email', value: userdetailModaldata?.email },
    { label: 'Mobile', value: userdetailModaldata?.mobileNo },
    { label: 'Office', value: userdetailModaldata?.office?.additionalCharge?.length? `Main Charge: ${userdetailModaldata?.office.mainCharge}. Additional Charge: ${userdetailModaldata.office?.additionalCharge.join(", ")}`: `Main Charge: ${userdetailModaldata?.office?.mainCharge}. (No Additional Charge)`},
    { label: 'Designation', value:userdetailModaldata? Object.entries(userdetailModaldata?.designation)?.map(x => `${x[1]} (${x[0]}) `).join(", "):"" },
    { label: 'Designation Suffix', value:userdetailModaldata?.designationSuffix?.length?  Object.entries(userdetailModaldata?.designationSuffix).map(x => `${x[1]} (${x[0]}) `).join(","): "Not Applicable" },
    { label: 'Roles', value: `Main: (${userdetailModaldata?.roles.main.join(", ")}). Other: ${Object.entries(userdetailModaldata.roles).filter(x=> x[0] !== "main" ).map(item =>  `${item[0]} (${item[1]})`).join(", ")} ` },
  ]:[];
  return (
    <React.Fragment>
      <Dialog  onClose={handleUserDetailModalClose} aria-labelledby="customized-dialog-title" open={userdetailmodalopen}>
        <DialogTitle>
          <Span>User Details</Span>
        </DialogTitle>
          <DialogContent dividers>
            <ModalContent>
              <Table>
              <tbody>
              {fields.map((item, index)=>
                <tr id='email' key ={index}>
                    <TableCell>
                      <TableHeader>
                        {item?.label}
                      </TableHeader>
                    </TableCell>
                    
                    <TableCell>
                      { item?.value}
                    </TableCell>
                  </tr>
                )
              }              
            </tbody>
                  </Table>
            </ModalContent>
          </DialogContent>

            <DialogActions >
              <Button onClick={handleUserDetailModalClose}>Close</Button>
            </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
